import { render, staticRenderFns } from "./UserGuideDetail.vue?vue&type=template&id=0be0b7fe&lang=true&"
import script from "./UserGuideDetail.vue?vue&type=script&lang=js&"
export * from "./UserGuideDetail.vue?vue&type=script&lang=js&"
import style0 from "./UserGuideDetail.vue?vue&type=style&index=0&id=0be0b7fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports